import { createPatchEndpoint } from '@sonar-software/sonar-http';

import { ComplianceCategory, DataSensitivityLevelId, FieldUsageId } from '@types';

type PatchHelpTextRequest = {
	helpText: string;
};

type PatchDescriptionRequest = {
	description: string;
};

type PatchFieldUsageRequest = {
	fieldUsageId: FieldUsageId;
};

type PatchDataSensitivityRequest = {
	dataSensitivityLevelId: DataSensitivityLevelId;
};

type PatchComplianceCategoryRequest = {
	complianceCategory: ComplianceCategory;
};

export type PatchSalesforceSonarObjectRequest = {
	sonarObjectId: number;
} & (PatchHelpTextRequest |
	PatchDescriptionRequest |
	PatchFieldUsageRequest |
	PatchDataSensitivityRequest |
	PatchComplianceCategoryRequest);

export type PatchSalesforceSonarObjectResponse = {
	success: boolean;
	message: string;
};

export const patchSalesforceSonarObject = createPatchEndpoint<
	PatchSalesforceSonarObjectRequest,
	PatchSalesforceSonarObjectResponse
>((request) => `/api/v3/salesforce/sonar-objects/${request.sonarObjectId}`);
